import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import * as bootstrap from 'bootstrap';

@customElement('tm-tpc-corrector-error-modal')
export class TmTPCCorrectorErrorModal extends LitElement {
    createRenderRoot() {
        return this;
    }

    @property({ type: Boolean })
    isImageError: boolean = false;

    showModal() {
        const modalElement = document.querySelector('#tm-tpc-corrector-error-modal');
        if (modalElement) {
            const bootstrapModal = bootstrap.Modal.getOrCreateInstance(modalElement, {
                backdrop: 'static',
                keyboard: false,
            });
            bootstrapModal.show();
        }
    }

    dismissModal() {
        const modalElement = document.querySelector('#tm-tpc-corrector-error-modal');
        if (modalElement) {
            const bootstrapModal = bootstrap.Modal.getInstance(modalElement);
            bootstrapModal.hide();
        }
    }

    firstUpdated() {
        this.showModal();
    }

    emitNewQuestion() {
        this.dismissModal();
        this.dispatchEvent(new CustomEvent('newQuestion'));
    }
    emitTryAgain() {
        this.dismissModal();
        this.dispatchEvent(new CustomEvent('tryAgain'));
    }

    renderGenericError() {
        return html`
            <p>Parece que houve um problema ao processar sua questão.</p>
            <p>
                Isso pode ter ocorrido devido a uma queda de conexão à internet ou porque nossa IA
                está passando por manutenção temporária.
            </p>
            <p>
                Vamos tentar novamente? Se o problema persistir, verifique sua conexão e tente mais
                tarde.
            </p>
        `;
    }

    renderImageError() {
        return html`
            <p>Não conseguimos processar sua imagem.</p>
            <p>
                Certifique-se de que o arquivo está em um formato suportado <b>(JPG ou PNG)</b> e não ultrapassa <b>20MB</b>.
            </p>
        `;
    }

    render() {
        return html`
            <div
                class="modal fade tm-tpc-corrector-error-modal"
                data-bs-backdrop="static"
                id="tm-tpc-corrector-error-modal"
                tabindex="-1"
                aria-hidden="true"
            >
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="tm-tpc-corrector-error-modal-title">
                            <span class="icon icon-054-alert-outline"></span>
                            Oops! Algo deu errado.
                        </div>
                        <div class="tm-tpc-corrector-error-modal-content">
                            ${this.isImageError
                                ? this.renderImageError()
                                : this.renderGenericError()}
                        </div>
                        <div class="tm-tpc-corrector-error-modal-footer">
                            ${this.isImageError
                                ? html` <button
                                      class="ds-button ds-button--primary"
                                      @click=${this.emitTryAgain}
                                  >
                                      <span class="icon 077-image-replace"></span>
                                      Enviar outra imagem
                                  </button>`
                                : html` <button
                                      class="ds-button ds-button--primary"
                                      @click=${this.emitTryAgain}
                                  >
                                      <span class="icon icon-021-restart"></span>
                                      Tentar novamente
                                  </button>`}
                            <button
                                class="ds-button ds-button--reverse"
                                @click=${this.emitNewQuestion}
                            >
                                <span class="icon icon-050-doc-write"></span>
                                Nova questão
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
